import type { CollectionFetchOptions } from 'backbone';
import Backbone from 'backbone';

import { getEnv } from '@luna/env';
import { triggerGlobalEvent } from '@luna/events';
import { INSTANCE_NAMES, setInstance } from '@retail/single-instance-cache';
import { queryDeprecatedUserConfigurations } from '@shared/user-configuration';

import { UserConfigurationModel } from './userConfigurationModel';
import { getUserConfiguration } from './UserConfigurationService';

export class UserConfigurationCollection extends Backbone.Collection {
    constructor(models?: UserConfigurationModel[], options?: any) {
        super(models, options);
        // @ts-expect-error ignore model override
        this.model = UserConfigurationModel;
    }

    startListeningToLoaded() {
        this.listenTo(this, 'sync', this.collectionLoaded);
    }

    // @ts-expect-error: ignore duplicate identifier issue
    url() {
        return `${getEnv().georgeApiUrl}my/configuration`;
    }

    // @ts-expect-error ignore override
    fetch(options: CollectionFetchOptions | undefined = {}) {
        return queryDeprecatedUserConfigurations(options)
            .then(() => {
                options.success?.();
            })
            .catch((error) => {
                options.error?.(this, error);
            });
    }

    fetchSuccess(userConfiguration: any, options: any) {
        // @ts-expect-error ignore unknown option
        this.set(userConfiguration, { parse: true });
        this.trigger('sync', this);
        if (options?.success) {
            options.success();
        }
    }

    parse(response: any) {
        const configs: any[] = [];
        Object.keys(response).forEach((selKey) => {
            if (response[selKey]) {
                const config = response[selKey];
                config.id = selKey;
                configs.push(config);
            }
        });
        return configs;
    }

    collectionLoaded() {
        triggerGlobalEvent('userConfig:loaded');
    }

    addFrontendConfig() {
        if (!this.get('frontend')) {
            // Set default
            const nConfig = new UserConfigurationModel({
                id: 'frontend',
                soundEnabled: true,
                upcomingLookahead: 14,
                startFolded: 0,
                setupShown: false,
            });
            this.add(nConfig);
        }

        setInstance(INSTANCE_NAMES.USER_CONFIGURATION, this.get('frontend'));
    }

    saveLanguage(language: string) {
        const frontendConfig = getUserConfiguration();

        if (frontendConfig.get('language') === language) {
            return null;
        }

        frontendConfig.set('language', language);

        return frontendConfig.save();
    }

    addNewConfig(newId: string) {
        const nConfig = new UserConfigurationModel({
            id: newId,
        });
        this.add(nConfig);
        return nConfig;
    }

    resetConfig(newId: string) {
        if (this.get(newId)) {
            this.remove(this.get(newId));
            return this.addNewConfig(newId);
        }
        return null;
    }
}
